var map = {
	"./X33-Mall_small.jpg": 710,
	"./all.svg": 711,
	"./apple-watch.png": 712,
	"./b-headphone.png": 713,
	"./coin.svg": 714,
	"./delete-btn.svg": 715,
	"./iphone-pink.png": 716,
	"./love.svg": 717,
	"./mall-banner-cn.jpg": 718,
	"./mall-banner-id.jpg": 719,
	"./mall-banner-ms.jpg": 720,
	"./mall-banner.jpg": 721,
	"./mobile-bg.jpg": 722,
	"./price-high.svg": 723,
	"./price-low.svg": 724,
	"./shopping-cart.svg": 725,
	"./star.svg": 726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;